module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"purchased_at":"{0} Purchase","best_review_reward":"Get up to {0} for being selected as a top review!"}}')
  delete Component.options._Ctor
}
